import { VariableGlobalsService } from "@/service/services/VariableGlobal.service";
import { Typography } from "@mui/material";
import { useState } from "react";
import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalFooter } from "../ModalFooter";
import { ModalHeader } from "../ModalHeader";
import { Props } from "./ModalVariableGlobalDelete.type";

export const ModalVariableGlobalDelete: React.FC<Props> = (props:any): JSX.Element => {
    const { open, closeModal, variableGlobal, onListVariableGlobal, clearState } = props;
    const [loading, setLoading] = useState<boolean>(false);

    const onDeleted= async()=>{
        setLoading(true);
        await VariableGlobalsService.deleteVariableGlobal(variableGlobal.id).then((data) => {
            onListVariableGlobal && onListVariableGlobal();
            closeModal && closeModal();
        })
        setLoading(false);
    }
  
    return (
        <>
        <Modal
        open={open}
        handleClose={closeModal}
        size="xs"
        >
        <ModalHeader
            text="ELIMINAR VARIABLE GLOBAL"
            className='positionElements'
            onCancel={closeModal}
            clearState={clearState}
        >
        </ModalHeader>

        <ModalBody>
            <Typography variant="subtitle1" className="textColor"> 
            ¿Está seguro de eliminar esta variable global?
            </Typography>
        </ModalBody>

        <ModalFooter 
            confirmText="Eliminar"
            cancelText="CANCELAR"
            onCancel={closeModal}
            className="footerRight"
            onConfirm={onDeleted}
            clearState={clearState}
        />
        </Modal>
        </>
    )
}